import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import { Epidemic } from '../../components/examples/';
export const _frontmatter = {
  "Title": "Epidemic"
};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "epidemic"
    }}>{`Epidemic`}</h1>
    <Epidemic mdxType="Epidemic" />
    <h3 {...{
      "id": "caveat"
    }}>{`Caveat`}</h3>
    <p>{`The purpose of this model is just to show how simulations work in React. It has no scientific value.`}</p>
    <p>{`This epidemic simulator is inspired by the work of `}<a parentName="p" {...{
        "href": "https://www.washingtonpost.com/graphics/2020/world/corona-simulator/"
      }}>{`Harry Stevens at the Washington Post`}</a>{`.
Again, this react-sim version was made without any scientific supervision and the parameters are just put in so it can look interesting.`}</p>
    <p>{`We have a number of agents moving in a small space. When they collide, "sick" agents may contaminate "healthy" agents, and "sick" agents may die.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      